export const restoreNewline = (input: string) => {
  return input.replace(/\\n/g, '\n');
};
